import React from 'react';
import CartTable from './cartTable';
import { inject, observer } from "mobx-react";
import { Link } from 'react-router-dom';
import GreenSubmitButton from '../../buttons/greenSubmitButton';
import emptyCartImg from '../../img/emptyCart_yellow.png';
import "./Cart.css";

// Translations
import _useTranslate from '../../hooks/_useTranslate';

const Cart = ({feathersStore})=> {

  let cart = _useTranslate(feathersStore.language, "cart");

  return(

      <div className="body-container">
       <div className="grey-header">{cart.cart}</div>
        {feathersStore.cartLength !== 0 ? <CartTable/> : (
          <div className="empty-cart-state">
            <img src={emptyCartImg} alt="" className="empty-cart-img" />
            <p className="empty-cart-text">{cart.emptyCart || "Your cart is empty"}</p>
            <Link to="/" style={{ textDecoration: 'none' }}>
              <GreenSubmitButton title={cart.continueShopping || "CONTINUE ORDERING"} />
            </Link>
          </div>
        )}
      </div>

  )
}

export default inject('feathersStore')(observer(Cart));
